/*
  The watcher is  funtion responsible the verify all rules
  this take a acomulador of rules and a data recived
  if this data breack any rule this push the rule in the acomulador
  return the acomulator
*/

import Rules from './rules'

let rules = Rules()

export const watcher = (acomulador, current) => {
  let match = rules
    .map((rule, i) => ({ ...rule, index: i }))
    .filter(rule =>
      rule.location === current.location &&
      rule.name === current.name &&
      rule.nextUpdate <= current.data[0]
    )
    .find(rule => {
      switch (rule.type) {
        case 'gt':
          return current.data[1] > rule.value
        case 'lt':
          return current.data[1] < rule.value
        case 'eq':
          return current.data[1] === rule.value
        default:
          return false
      }
    })

  if (match) {
    // Updata the rules
    rules = [
      ...rules.filter(rule => !(rule.id === match.id)),
      {
        ...match,
        nextUpdate: current.data[0] + 3 * 60 * 1000
      }
    ]
    return [
      ...acomulador,
      {
        ...match,
        lastUpdate: current.data[0],
        lastValue: current.data[1]
      }
    ]
  }
  return acomulador
}



// WEBPACK FOOTER //
// ./src/store/watcher.js